module.exports = __webpack_public_path__ + "media/images/gallery/constellations/pn_layer_off-ff4550e919e5cfdee5b0259f7ef3bb3e.jpg";